export const en = {
	// titles
	'Fishplace – это надежно': 'Fishplace is reliable',
	'Выберите тариф': 'Choose a tariff',
	'Ожидается оплата': 'Payment is expected',

	// description
	'Миссия Fishplace — предоставить доступ к множеству надежных, интересных предложений и сделать процесс выбора партнера максимально удобным и безопасным.':
		'Fishplace\'s mission is to provide access to a variety of reliable, interesting offers and make the process of choosing a partner as convenient and safe as possible.',
	'Мы — платформа для профессионалов рыбного рынка и предоставляем доступ к данным только отраслевым зарегистрированным пользователям.':
		'We are a platform for professionals in the fish market and provide access to data only to industry-registered users.',
	'Для продолжения использования платформы, необходимо выбрать один из доступных тарифов и произвести оплату.':
		'To continue using the platform, you need to choose one of the available tariffs and make a payment.',
	'Ожидаем оплату по счету. Оплата будет зачислена после поступления средств на расчетный счет.':
		'We expect payment on invoice. Payment will be credited after the funds are received on the settlement account.',

	// buttons text
	Зарегистрироваться: 'Sign Up',
	'Выбрать тариф': 'Choose a tariff',

	// first notes
	'Хотите протестировать платформу самостоятельно?':
		'If you want to test the platform yourself, go to the',
	'Демоверсия платформы': 'demo site.',

	// second notes
	'Нужна помощь и сопровождение?': 'Need help and support - ',
	'Закажите экскурсию': 'request a platform demonstration.',

	// modal titles
	'Экскурсия по платформе': 'Platform demonstration',
};
